/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const setMaxVideosLimitReachedEvent = /* GraphQL */ `
  mutation SetMaxVideosLimitReachedEvent(
    $input: SetMaxVideosLimitReachedEventInput
  ) {
    setMaxVideosLimitReachedEvent(input: $input) {
      maxVideosLimitReachedTimesFor30days
    }
  }
`;
export const getOrCreateCustomer = /* GraphQL */ `
  mutation GetOrCreateCustomer($input: CreateScreensightCustomerInput) {
    getOrCreateCustomer(input: $input) {
      id
      email
      firstName
      lastName
      profilePhoto {
        key
        bucket
        accessLevel
        identityId
      }
      brandLogo {
        key
        bucket
        accessLevel
        identityId
      }
      calendlyUrl
      lastSeen
      settings {
        notifyEmailWatched
        notifyEmailComment
        notifyUnseenMessages
        timezone
        pushNotifications {
          video
          comment
          reply
          text
        }
        lastChannel
        enableSplashScreen
        termsAndConditions {
          version
          accepted
          acceptedAt
        }
        channelRecentActivityDays
      }
      stripeId
      createdAt
      updatedAt
    }
  }
`;
export const createBillingPaymentMethod = /* GraphQL */ `
  mutation CreateBillingPaymentMethod($input: CreatePaymentMethodInput!) {
    createBillingPaymentMethod(input: $input) {
      brand
      nameOnCard
      expirationMonth
      expirationYear
      lastFourDigits
    }
  }
`;
export const updateBillingPaymentMethod = /* GraphQL */ `
  mutation UpdateBillingPaymentMethod($input: UpdatePaymentMethodInput!) {
    updateBillingPaymentMethod(input: $input) {
      brand
      nameOnCard
      expirationMonth
      expirationYear
      lastFourDigits
    }
  }
`;
export const deleteBillingPaymentMethod = /* GraphQL */ `
  mutation DeleteBillingPaymentMethod {
    deleteBillingPaymentMethod {
      brand
      nameOnCard
      expirationMonth
      expirationYear
      lastFourDigits
    }
  }
`;
export const createBillingSubscription = /* GraphQL */ `
  mutation CreateBillingSubscription($input: BillingSubscriptionInput!) {
    createBillingSubscription(input: $input) {
      id
      price {
        id
        currency
        interval
        amount
      }
      product {
        name
        description
        prices {
          id
          currency
          interval
          amount
        }
      }
    }
  }
`;
export const updateBillingSubscription = /* GraphQL */ `
  mutation UpdateBillingSubscription($input: BillingSubscriptionInput!) {
    updateBillingSubscription(input: $input) {
      id
      price {
        id
        currency
        interval
        amount
      }
      product {
        name
        description
        prices {
          id
          currency
          interval
          amount
        }
      }
    }
  }
`;
export const cancelBillingSubscription = /* GraphQL */ `
  mutation CancelBillingSubscription {
    cancelBillingSubscription {
      id
      price {
        id
        currency
        interval
        amount
      }
      product {
        name
        description
        prices {
          id
          currency
          interval
          amount
        }
      }
    }
  }
`;
export const createChannel = /* GraphQL */ `
  mutation CreateChannel(
    $input: CreateScreensightChannelInput!
    $condition: ModelScreensightChannelConditionInput
  ) {
    createChannel(input: $input, condition: $condition) {
      id
      customerId
      channelType
      name
      categoryPosition
      readHorizon
      activity {
        new
        latestAt
        latestPost {
          id
          channelId
          accessId
          customerId
          postType
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          comment {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          emailMessage {
            id
            videoId
            customerId
            channelId
            to
            note
            emailStatus {
              email
              status
              reject_reason
              _id
              deliveredAt
              opens
            }
            subject
            contacts {
              email
              contactId
            }
            createdAt
            updatedAt
          }
          text {
            content
            richContent
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
          }
          referencePostId
          referencePost {
            id
            channelId
            accessId
            customerId
            postType
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            comment {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            emailMessage {
              id
              videoId
              customerId
              channelId
              to
              note
              emailStatus {
                email
                status
                reject_reason
                _id
                deliveredAt
                opens
              }
              subject
              contacts {
                email
                contactId
              }
              createdAt
              updatedAt
            }
            text {
              content
              richContent
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
            }
            referencePostId
            referencePost {
              id
              channelId
              accessId
              customerId
              postType
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              comment {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              emailMessage {
                id
                videoId
                customerId
                channelId
                to
                note
                emailStatus {
                  email
                  status
                  reject_reason
                  _id
                  deliveredAt
                  opens
                }
                subject
                contacts {
                  email
                  contactId
                }
                createdAt
                updatedAt
              }
              text {
                content
                richContent
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
              }
              referencePostId
              referencePost {
                id
                channelId
                accessId
                customerId
                postType
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                comment {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                emailMessage {
                  id
                  videoId
                  customerId
                  channelId
                  to
                  note
                  subject
                  createdAt
                  updatedAt
                }
                text {
                  content
                  richContent
                  customerId
                }
                referencePostId
                referencePost {
                  id
                  channelId
                  accessId
                  customerId
                  postType
                  referencePostId
                  createdAt
                  updatedAt
                }
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      chatPartnerId
      chatPartnerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      latestPostAt
      createdAt
      updatedAt
    }
  }
`;
export const updateChannel = /* GraphQL */ `
  mutation UpdateChannel(
    $input: UpdateScreensightChannelInput!
    $condition: ModelScreensightChannelConditionInput
  ) {
    updateChannel(input: $input, condition: $condition) {
      id
      customerId
      channelType
      name
      categoryPosition
      readHorizon
      activity {
        new
        latestAt
        latestPost {
          id
          channelId
          accessId
          customerId
          postType
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          comment {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          emailMessage {
            id
            videoId
            customerId
            channelId
            to
            note
            emailStatus {
              email
              status
              reject_reason
              _id
              deliveredAt
              opens
            }
            subject
            contacts {
              email
              contactId
            }
            createdAt
            updatedAt
          }
          text {
            content
            richContent
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
          }
          referencePostId
          referencePost {
            id
            channelId
            accessId
            customerId
            postType
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            comment {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            emailMessage {
              id
              videoId
              customerId
              channelId
              to
              note
              emailStatus {
                email
                status
                reject_reason
                _id
                deliveredAt
                opens
              }
              subject
              contacts {
                email
                contactId
              }
              createdAt
              updatedAt
            }
            text {
              content
              richContent
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
            }
            referencePostId
            referencePost {
              id
              channelId
              accessId
              customerId
              postType
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              comment {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              emailMessage {
                id
                videoId
                customerId
                channelId
                to
                note
                emailStatus {
                  email
                  status
                  reject_reason
                  _id
                  deliveredAt
                  opens
                }
                subject
                contacts {
                  email
                  contactId
                }
                createdAt
                updatedAt
              }
              text {
                content
                richContent
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
              }
              referencePostId
              referencePost {
                id
                channelId
                accessId
                customerId
                postType
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                comment {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                emailMessage {
                  id
                  videoId
                  customerId
                  channelId
                  to
                  note
                  subject
                  createdAt
                  updatedAt
                }
                text {
                  content
                  richContent
                  customerId
                }
                referencePostId
                referencePost {
                  id
                  channelId
                  accessId
                  customerId
                  postType
                  referencePostId
                  createdAt
                  updatedAt
                }
                createdAt
                updatedAt
              }
              createdAt
              updatedAt
            }
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
      }
      chatPartnerId
      chatPartnerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      latestPostAt
      createdAt
      updatedAt
    }
  }
`;
export const createPost = /* GraphQL */ `
  mutation CreatePost(
    $input: CreateScreensightPostInput!
    $condition: ModelScreensightPostConditionInput
  ) {
    createPost(input: $input, condition: $condition) {
      id
      channelId
      accessId
      customerId
      postType
      video {
        id
        createdAt
        customerId
        channelId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        title
        searchTitle
        status
        fileObject {
          key
          bucket
          accessLevel
          identityId
        }
        filePresignedUrl
        duration
        name
        thumbnailObject {
          key
          bucket
          accessLevel
          identityId
        }
        accessType
        accessId
        password
        width
        height
        viewsCountTotal
        viewsCountUnique
        viewsList {
          items {
            videoId
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            guestName
            viewCount
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          nextToken
          count
        }
        commentsCount
        uploadedVideo {
          fileName
          videoContainer
          videoEncoding
        }
        transcriptionSummaryStatus
        transcriptionSummaryError
        transcriptionSummary
        transcriptionObject {
          key
          bucket
          accessLevel
          identityId
        }
        updatedAt
      }
      comment {
        id
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        videoId
        channelId
        parentId
        content
        richContent
        videoTimestamp
        resolved
        replies {
          items {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          nextToken
          count
        }
        replyCount
        parentCreatedAt
        createdAt
        updatedAt
      }
      emailMessage {
        id
        videoId
        customerId
        channelId
        to
        note
        emailStatus {
          email
          status
          reject_reason
          _id
          deliveredAt
          opens
        }
        subject
        contacts {
          email
          contactId
        }
        createdAt
        updatedAt
      }
      text {
        content
        richContent
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
      }
      file {
        fileName
        fileObject {
          key
          bucket
          accessLevel
          identityId
        }
        status
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        mimeType
        metadata
      }
      engagement {
        items {
          customerId
          seen
          seenAt
          videoProgress
        }
        nextToken
      }
      referencePostId
      referencePost {
        id
        channelId
        accessId
        customerId
        postType
        video {
          id
          createdAt
          customerId
          channelId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          title
          searchTitle
          status
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          filePresignedUrl
          duration
          name
          thumbnailObject {
            key
            bucket
            accessLevel
            identityId
          }
          accessType
          accessId
          password
          width
          height
          viewsCountTotal
          viewsCountUnique
          viewsList {
            items {
              videoId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              guestName
              viewCount
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          comments {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          commentsCount
          uploadedVideo {
            fileName
            videoContainer
            videoEncoding
          }
          transcriptionSummaryStatus
          transcriptionSummaryError
          transcriptionSummary
          transcriptionObject {
            key
            bucket
            accessLevel
            identityId
          }
          updatedAt
        }
        comment {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        emailMessage {
          id
          videoId
          customerId
          channelId
          to
          note
          emailStatus {
            email
            status
            reject_reason
            _id
            deliveredAt
            opens
          }
          subject
          contacts {
            email
            contactId
          }
          createdAt
          updatedAt
        }
        text {
          content
          richContent
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
        }
        file {
          fileName
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          status
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          mimeType
          metadata
        }
        engagement {
          items {
            customerId
            seen
            seenAt
            videoProgress
          }
          nextToken
        }
        referencePostId
        referencePost {
          id
          channelId
          accessId
          customerId
          postType
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          comment {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          emailMessage {
            id
            videoId
            customerId
            channelId
            to
            note
            emailStatus {
              email
              status
              reject_reason
              _id
              deliveredAt
              opens
            }
            subject
            contacts {
              email
              contactId
            }
            createdAt
            updatedAt
          }
          text {
            content
            richContent
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
          }
          file {
            fileName
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            status
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            mimeType
            metadata
          }
          engagement {
            items {
              customerId
              seen
              seenAt
              videoProgress
            }
            nextToken
          }
          referencePostId
          referencePost {
            id
            channelId
            accessId
            customerId
            postType
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            comment {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            emailMessage {
              id
              videoId
              customerId
              channelId
              to
              note
              emailStatus {
                email
                status
                reject_reason
                _id
                deliveredAt
                opens
              }
              subject
              contacts {
                email
                contactId
              }
              createdAt
              updatedAt
            }
            text {
              content
              richContent
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
            }
            file {
              fileName
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              status
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              mimeType
              metadata
            }
            engagement {
              items {
                customerId
                seen
                seenAt
                videoProgress
              }
              nextToken
            }
            referencePostId
            referencePost {
              id
              channelId
              accessId
              customerId
              postType
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              comment {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              emailMessage {
                id
                videoId
                customerId
                channelId
                to
                note
                emailStatus {
                  email
                  status
                  reject_reason
                  _id
                  deliveredAt
                  opens
                }
                subject
                contacts {
                  email
                  contactId
                }
                createdAt
                updatedAt
              }
              text {
                content
                richContent
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
              }
              file {
                fileName
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                status
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                mimeType
                metadata
              }
              engagement {
                items {
                  customerId
                  seen
                  seenAt
                  videoProgress
                }
                nextToken
              }
              referencePostId
              referencePost {
                id
                channelId
                accessId
                customerId
                postType
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                comment {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                emailMessage {
                  id
                  videoId
                  customerId
                  channelId
                  to
                  note
                  subject
                  createdAt
                  updatedAt
                }
                text {
                  content
                  richContent
                  customerId
                }
                file {
                  fileName
                  status
                  customerId
                  mimeType
                  metadata
                }
                engagement {
                  nextToken
                }
                referencePostId
                referencePost {
                  id
                  channelId
                  accessId
                  customerId
                  postType
                  referencePostId
                  readHorizon
                  postTempId
                  createdAt
                  updatedAt
                }
                readHorizon
                postTempId
                reactions {
                  nextToken
                }
                createdAt
                updatedAt
              }
              readHorizon
              postTempId
              reactions {
                items {
                  postId
                  customerId
                  unicode
                  videoTimestamp
                  channelId
                  incrementBy
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              updatedAt
            }
            readHorizon
            postTempId
            reactions {
              items {
                postId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                unicode
                videoTimestamp
                channelId
                incrementBy
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          readHorizon
          postTempId
          reactions {
            items {
              postId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              unicode
              videoTimestamp
              channelId
              incrementBy
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        readHorizon
        postTempId
        reactions {
          items {
            postId
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            unicode
            videoTimestamp
            channelId
            incrementBy
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      readHorizon
      postTempId
      reactions {
        items {
          postId
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          unicode
          videoTimestamp
          channelId
          incrementBy
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updatePost = /* GraphQL */ `
  mutation UpdatePost(
    $input: UpdateScreensightPostInput!
    $condition: ModelScreensightPostConditionInput
  ) {
    updatePost(input: $input, condition: $condition) {
      id
      channelId
      accessId
      customerId
      postType
      video {
        id
        createdAt
        customerId
        channelId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        title
        searchTitle
        status
        fileObject {
          key
          bucket
          accessLevel
          identityId
        }
        filePresignedUrl
        duration
        name
        thumbnailObject {
          key
          bucket
          accessLevel
          identityId
        }
        accessType
        accessId
        password
        width
        height
        viewsCountTotal
        viewsCountUnique
        viewsList {
          items {
            videoId
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            guestName
            viewCount
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          nextToken
          count
        }
        commentsCount
        uploadedVideo {
          fileName
          videoContainer
          videoEncoding
        }
        transcriptionSummaryStatus
        transcriptionSummaryError
        transcriptionSummary
        transcriptionObject {
          key
          bucket
          accessLevel
          identityId
        }
        updatedAt
      }
      comment {
        id
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        videoId
        channelId
        parentId
        content
        richContent
        videoTimestamp
        resolved
        replies {
          items {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          nextToken
          count
        }
        replyCount
        parentCreatedAt
        createdAt
        updatedAt
      }
      emailMessage {
        id
        videoId
        customerId
        channelId
        to
        note
        emailStatus {
          email
          status
          reject_reason
          _id
          deliveredAt
          opens
        }
        subject
        contacts {
          email
          contactId
        }
        createdAt
        updatedAt
      }
      text {
        content
        richContent
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
      }
      file {
        fileName
        fileObject {
          key
          bucket
          accessLevel
          identityId
        }
        status
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        mimeType
        metadata
      }
      engagement {
        items {
          customerId
          seen
          seenAt
          videoProgress
        }
        nextToken
      }
      referencePostId
      referencePost {
        id
        channelId
        accessId
        customerId
        postType
        video {
          id
          createdAt
          customerId
          channelId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          title
          searchTitle
          status
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          filePresignedUrl
          duration
          name
          thumbnailObject {
            key
            bucket
            accessLevel
            identityId
          }
          accessType
          accessId
          password
          width
          height
          viewsCountTotal
          viewsCountUnique
          viewsList {
            items {
              videoId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              guestName
              viewCount
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          comments {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          commentsCount
          uploadedVideo {
            fileName
            videoContainer
            videoEncoding
          }
          transcriptionSummaryStatus
          transcriptionSummaryError
          transcriptionSummary
          transcriptionObject {
            key
            bucket
            accessLevel
            identityId
          }
          updatedAt
        }
        comment {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        emailMessage {
          id
          videoId
          customerId
          channelId
          to
          note
          emailStatus {
            email
            status
            reject_reason
            _id
            deliveredAt
            opens
          }
          subject
          contacts {
            email
            contactId
          }
          createdAt
          updatedAt
        }
        text {
          content
          richContent
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
        }
        file {
          fileName
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          status
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          mimeType
          metadata
        }
        engagement {
          items {
            customerId
            seen
            seenAt
            videoProgress
          }
          nextToken
        }
        referencePostId
        referencePost {
          id
          channelId
          accessId
          customerId
          postType
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          comment {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          emailMessage {
            id
            videoId
            customerId
            channelId
            to
            note
            emailStatus {
              email
              status
              reject_reason
              _id
              deliveredAt
              opens
            }
            subject
            contacts {
              email
              contactId
            }
            createdAt
            updatedAt
          }
          text {
            content
            richContent
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
          }
          file {
            fileName
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            status
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            mimeType
            metadata
          }
          engagement {
            items {
              customerId
              seen
              seenAt
              videoProgress
            }
            nextToken
          }
          referencePostId
          referencePost {
            id
            channelId
            accessId
            customerId
            postType
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            comment {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            emailMessage {
              id
              videoId
              customerId
              channelId
              to
              note
              emailStatus {
                email
                status
                reject_reason
                _id
                deliveredAt
                opens
              }
              subject
              contacts {
                email
                contactId
              }
              createdAt
              updatedAt
            }
            text {
              content
              richContent
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
            }
            file {
              fileName
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              status
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              mimeType
              metadata
            }
            engagement {
              items {
                customerId
                seen
                seenAt
                videoProgress
              }
              nextToken
            }
            referencePostId
            referencePost {
              id
              channelId
              accessId
              customerId
              postType
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              comment {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              emailMessage {
                id
                videoId
                customerId
                channelId
                to
                note
                emailStatus {
                  email
                  status
                  reject_reason
                  _id
                  deliveredAt
                  opens
                }
                subject
                contacts {
                  email
                  contactId
                }
                createdAt
                updatedAt
              }
              text {
                content
                richContent
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
              }
              file {
                fileName
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                status
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                mimeType
                metadata
              }
              engagement {
                items {
                  customerId
                  seen
                  seenAt
                  videoProgress
                }
                nextToken
              }
              referencePostId
              referencePost {
                id
                channelId
                accessId
                customerId
                postType
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                comment {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                emailMessage {
                  id
                  videoId
                  customerId
                  channelId
                  to
                  note
                  subject
                  createdAt
                  updatedAt
                }
                text {
                  content
                  richContent
                  customerId
                }
                file {
                  fileName
                  status
                  customerId
                  mimeType
                  metadata
                }
                engagement {
                  nextToken
                }
                referencePostId
                referencePost {
                  id
                  channelId
                  accessId
                  customerId
                  postType
                  referencePostId
                  readHorizon
                  postTempId
                  createdAt
                  updatedAt
                }
                readHorizon
                postTempId
                reactions {
                  nextToken
                }
                createdAt
                updatedAt
              }
              readHorizon
              postTempId
              reactions {
                items {
                  postId
                  customerId
                  unicode
                  videoTimestamp
                  channelId
                  incrementBy
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              updatedAt
            }
            readHorizon
            postTempId
            reactions {
              items {
                postId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                unicode
                videoTimestamp
                channelId
                incrementBy
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          readHorizon
          postTempId
          reactions {
            items {
              postId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              unicode
              videoTimestamp
              channelId
              incrementBy
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        readHorizon
        postTempId
        reactions {
          items {
            postId
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            unicode
            videoTimestamp
            channelId
            incrementBy
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      readHorizon
      postTempId
      reactions {
        items {
          postId
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          unicode
          videoTimestamp
          channelId
          incrementBy
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deletePost = /* GraphQL */ `
  mutation DeletePost(
    $input: DeleteScreensightPostInput!
    $condition: ModelScreensightPostConditionInput
  ) {
    deletePost(input: $input, condition: $condition) {
      id
      channelId
      accessId
      customerId
      postType
      video {
        id
        createdAt
        customerId
        channelId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        title
        searchTitle
        status
        fileObject {
          key
          bucket
          accessLevel
          identityId
        }
        filePresignedUrl
        duration
        name
        thumbnailObject {
          key
          bucket
          accessLevel
          identityId
        }
        accessType
        accessId
        password
        width
        height
        viewsCountTotal
        viewsCountUnique
        viewsList {
          items {
            videoId
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            guestName
            viewCount
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            createdAt
            updatedAt
          }
          nextToken
        }
        comments {
          items {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          nextToken
          count
        }
        commentsCount
        uploadedVideo {
          fileName
          videoContainer
          videoEncoding
        }
        transcriptionSummaryStatus
        transcriptionSummaryError
        transcriptionSummary
        transcriptionObject {
          key
          bucket
          accessLevel
          identityId
        }
        updatedAt
      }
      comment {
        id
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        videoId
        channelId
        parentId
        content
        richContent
        videoTimestamp
        resolved
        replies {
          items {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          nextToken
          count
        }
        replyCount
        parentCreatedAt
        createdAt
        updatedAt
      }
      emailMessage {
        id
        videoId
        customerId
        channelId
        to
        note
        emailStatus {
          email
          status
          reject_reason
          _id
          deliveredAt
          opens
        }
        subject
        contacts {
          email
          contactId
        }
        createdAt
        updatedAt
      }
      text {
        content
        richContent
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
      }
      file {
        fileName
        fileObject {
          key
          bucket
          accessLevel
          identityId
        }
        status
        customerId
        customerMeta {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        mimeType
        metadata
      }
      engagement {
        items {
          customerId
          seen
          seenAt
          videoProgress
        }
        nextToken
      }
      referencePostId
      referencePost {
        id
        channelId
        accessId
        customerId
        postType
        video {
          id
          createdAt
          customerId
          channelId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          title
          searchTitle
          status
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          filePresignedUrl
          duration
          name
          thumbnailObject {
            key
            bucket
            accessLevel
            identityId
          }
          accessType
          accessId
          password
          width
          height
          viewsCountTotal
          viewsCountUnique
          viewsList {
            items {
              videoId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              guestName
              viewCount
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          comments {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          commentsCount
          uploadedVideo {
            fileName
            videoContainer
            videoEncoding
          }
          transcriptionSummaryStatus
          transcriptionSummaryError
          transcriptionSummary
          transcriptionObject {
            key
            bucket
            accessLevel
            identityId
          }
          updatedAt
        }
        comment {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        emailMessage {
          id
          videoId
          customerId
          channelId
          to
          note
          emailStatus {
            email
            status
            reject_reason
            _id
            deliveredAt
            opens
          }
          subject
          contacts {
            email
            contactId
          }
          createdAt
          updatedAt
        }
        text {
          content
          richContent
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
        }
        file {
          fileName
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          status
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          mimeType
          metadata
        }
        engagement {
          items {
            customerId
            seen
            seenAt
            videoProgress
          }
          nextToken
        }
        referencePostId
        referencePost {
          id
          channelId
          accessId
          customerId
          postType
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          comment {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          emailMessage {
            id
            videoId
            customerId
            channelId
            to
            note
            emailStatus {
              email
              status
              reject_reason
              _id
              deliveredAt
              opens
            }
            subject
            contacts {
              email
              contactId
            }
            createdAt
            updatedAt
          }
          text {
            content
            richContent
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
          }
          file {
            fileName
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            status
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            mimeType
            metadata
          }
          engagement {
            items {
              customerId
              seen
              seenAt
              videoProgress
            }
            nextToken
          }
          referencePostId
          referencePost {
            id
            channelId
            accessId
            customerId
            postType
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            comment {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            emailMessage {
              id
              videoId
              customerId
              channelId
              to
              note
              emailStatus {
                email
                status
                reject_reason
                _id
                deliveredAt
                opens
              }
              subject
              contacts {
                email
                contactId
              }
              createdAt
              updatedAt
            }
            text {
              content
              richContent
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
            }
            file {
              fileName
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              status
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              mimeType
              metadata
            }
            engagement {
              items {
                customerId
                seen
                seenAt
                videoProgress
              }
              nextToken
            }
            referencePostId
            referencePost {
              id
              channelId
              accessId
              customerId
              postType
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              comment {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              emailMessage {
                id
                videoId
                customerId
                channelId
                to
                note
                emailStatus {
                  email
                  status
                  reject_reason
                  _id
                  deliveredAt
                  opens
                }
                subject
                contacts {
                  email
                  contactId
                }
                createdAt
                updatedAt
              }
              text {
                content
                richContent
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
              }
              file {
                fileName
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                status
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                mimeType
                metadata
              }
              engagement {
                items {
                  customerId
                  seen
                  seenAt
                  videoProgress
                }
                nextToken
              }
              referencePostId
              referencePost {
                id
                channelId
                accessId
                customerId
                postType
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                comment {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                emailMessage {
                  id
                  videoId
                  customerId
                  channelId
                  to
                  note
                  subject
                  createdAt
                  updatedAt
                }
                text {
                  content
                  richContent
                  customerId
                }
                file {
                  fileName
                  status
                  customerId
                  mimeType
                  metadata
                }
                engagement {
                  nextToken
                }
                referencePostId
                referencePost {
                  id
                  channelId
                  accessId
                  customerId
                  postType
                  referencePostId
                  readHorizon
                  postTempId
                  createdAt
                  updatedAt
                }
                readHorizon
                postTempId
                reactions {
                  nextToken
                }
                createdAt
                updatedAt
              }
              readHorizon
              postTempId
              reactions {
                items {
                  postId
                  customerId
                  unicode
                  videoTimestamp
                  channelId
                  incrementBy
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              updatedAt
            }
            readHorizon
            postTempId
            reactions {
              items {
                postId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                unicode
                videoTimestamp
                channelId
                incrementBy
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          readHorizon
          postTempId
          reactions {
            items {
              postId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              unicode
              videoTimestamp
              channelId
              incrementBy
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        readHorizon
        postTempId
        reactions {
          items {
            postId
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            unicode
            videoTimestamp
            channelId
            incrementBy
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      readHorizon
      postTempId
      reactions {
        items {
          postId
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          unicode
          videoTimestamp
          channelId
          incrementBy
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createVideo = /* GraphQL */ `
  mutation CreateVideo(
    $input: CreateScreensightVideoInput!
    $condition: ModelScreensightVideoConditionInput
  ) {
    createVideo(input: $input, condition: $condition) {
      id
      createdAt
      customerId
      channelId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      title
      searchTitle
      status
      fileObject {
        key
        bucket
        accessLevel
        identityId
      }
      filePresignedUrl
      duration
      name
      thumbnailObject {
        key
        bucket
        accessLevel
        identityId
      }
      accessType
      accessId
      password
      width
      height
      viewsCountTotal
      viewsCountUnique
      viewsList {
        items {
          videoId
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          guestName
          viewCount
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        nextToken
        count
      }
      commentsCount
      uploadedVideo {
        fileName
        videoContainer
        videoEncoding
      }
      transcriptionSummaryStatus
      transcriptionSummaryError
      transcriptionSummary
      transcriptionObject {
        key
        bucket
        accessLevel
        identityId
      }
      updatedAt
    }
  }
`;
export const updateVideo = /* GraphQL */ `
  mutation UpdateVideo(
    $input: UpdateScreensightVideoInput!
    $condition: ModelScreensightVideoConditionInput
  ) {
    updateVideo(input: $input, condition: $condition) {
      id
      createdAt
      customerId
      channelId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      title
      searchTitle
      status
      fileObject {
        key
        bucket
        accessLevel
        identityId
      }
      filePresignedUrl
      duration
      name
      thumbnailObject {
        key
        bucket
        accessLevel
        identityId
      }
      accessType
      accessId
      password
      width
      height
      viewsCountTotal
      viewsCountUnique
      viewsList {
        items {
          videoId
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          guestName
          viewCount
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        nextToken
        count
      }
      commentsCount
      uploadedVideo {
        fileName
        videoContainer
        videoEncoding
      }
      transcriptionSummaryStatus
      transcriptionSummaryError
      transcriptionSummary
      transcriptionObject {
        key
        bucket
        accessLevel
        identityId
      }
      updatedAt
    }
  }
`;
export const deleteVideo = /* GraphQL */ `
  mutation DeleteVideo(
    $input: DeleteScreensightVideoInput!
    $condition: ModelScreensightVideoConditionInput
  ) {
    deleteVideo(input: $input, condition: $condition) {
      id
      createdAt
      customerId
      channelId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      title
      searchTitle
      status
      fileObject {
        key
        bucket
        accessLevel
        identityId
      }
      filePresignedUrl
      duration
      name
      thumbnailObject {
        key
        bucket
        accessLevel
        identityId
      }
      accessType
      accessId
      password
      width
      height
      viewsCountTotal
      viewsCountUnique
      viewsList {
        items {
          videoId
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          guestName
          viewCount
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        nextToken
        count
      }
      commentsCount
      uploadedVideo {
        fileName
        videoContainer
        videoEncoding
      }
      transcriptionSummaryStatus
      transcriptionSummaryError
      transcriptionSummary
      transcriptionObject {
        key
        bucket
        accessLevel
        identityId
      }
      updatedAt
    }
  }
`;
export const setVideoViewedBy = /* GraphQL */ `
  mutation SetVideoViewedBy($input: SetVideoViewedInput) {
    setVideoViewedBy(input: $input) {
      id
      createdAt
      customerId
      channelId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      title
      searchTitle
      status
      fileObject {
        key
        bucket
        accessLevel
        identityId
      }
      filePresignedUrl
      duration
      name
      thumbnailObject {
        key
        bucket
        accessLevel
        identityId
      }
      accessType
      accessId
      password
      width
      height
      viewsCountTotal
      viewsCountUnique
      viewsList {
        items {
          videoId
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          guestName
          viewCount
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        nextToken
        count
      }
      commentsCount
      uploadedVideo {
        fileName
        videoContainer
        videoEncoding
      }
      transcriptionSummaryStatus
      transcriptionSummaryError
      transcriptionSummary
      transcriptionObject {
        key
        bucket
        accessLevel
        identityId
      }
      updatedAt
    }
  }
`;
export const createVideoComment = /* GraphQL */ `
  mutation CreateVideoComment(
    $input: CreateScreensightVideoCommentInput!
    $condition: ModelScreensightVideoCommentConditionInput
  ) {
    createVideoComment(input: $input, condition: $condition) {
      id
      customerId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      videoId
      channelId
      parentId
      content
      richContent
      videoTimestamp
      resolved
      replies {
        items {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        nextToken
        count
      }
      replyCount
      parentCreatedAt
      createdAt
      updatedAt
    }
  }
`;
export const updateVideoComment = /* GraphQL */ `
  mutation UpdateVideoComment(
    $input: UpdateScreensightVideoCommentInput!
    $condition: ModelScreensightVideoCommentConditionInput
  ) {
    updateVideoComment(input: $input, condition: $condition) {
      id
      customerId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      videoId
      channelId
      parentId
      content
      richContent
      videoTimestamp
      resolved
      replies {
        items {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        nextToken
        count
      }
      replyCount
      parentCreatedAt
      createdAt
      updatedAt
    }
  }
`;
export const deleteVideoComment = /* GraphQL */ `
  mutation DeleteVideoComment(
    $input: DeleteScreensightVideoCommentInput!
    $condition: ModelScreensightVideoCommentConditionInput
  ) {
    deleteVideoComment(input: $input, condition: $condition) {
      id
      customerId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      videoId
      channelId
      parentId
      content
      richContent
      videoTimestamp
      resolved
      replies {
        items {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        nextToken
        count
      }
      replyCount
      parentCreatedAt
      createdAt
      updatedAt
    }
  }
`;
export const createEmailMessage = /* GraphQL */ `
  mutation CreateEmailMessage(
    $input: CreateScreensightVideoEmailMessageInput!
    $condition: ModelScreensightVideoEmailMessageConditionInput
  ) {
    createEmailMessage(input: $input, condition: $condition) {
      id
      videoId
      customerId
      channelId
      to
      note
      emailStatus {
        email
        status
        reject_reason
        _id
        deliveredAt
        opens
      }
      subject
      contacts {
        email
        contactId
      }
      createdAt
      updatedAt
    }
  }
`;
export const createEmailInThreads = /* GraphQL */ `
  mutation CreateEmailInThreads(
    $input: CreateScreensightVideoEmailMessageInput!
  ) {
    createEmailInThreads(input: $input) {
      executionArn
      startDate
    }
  }
`;
export const createReaction = /* GraphQL */ `
  mutation CreateReaction(
    $input: CreateScreensightReactionInput!
    $condition: ModelScreensightReactionConditionInput
  ) {
    createReaction(input: $input, condition: $condition) {
      postId
      customerId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      unicode
      videoTimestamp
      channelId
      incrementBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteReaction = /* GraphQL */ `
  mutation DeleteReaction(
    $input: DeleteScreensightReactionInput!
    $condition: ModelScreensightReactionConditionInput
  ) {
    deleteReaction(input: $input, condition: $condition) {
      postId
      customerId
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
      unicode
      videoTimestamp
      channelId
      incrementBy
      createdAt
      updatedAt
    }
  }
`;
export const sendPostEvent = /* GraphQL */ `
  mutation SendPostEvent($input: SendPostEventInput) {
    sendPostEvent(input: $input) {
      customerId
      channelId
      action
      post {
        id
        channelId
        accessId
        customerId
        postType
        video {
          id
          createdAt
          customerId
          channelId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          title
          searchTitle
          status
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          filePresignedUrl
          duration
          name
          thumbnailObject {
            key
            bucket
            accessLevel
            identityId
          }
          accessType
          accessId
          password
          width
          height
          viewsCountTotal
          viewsCountUnique
          viewsList {
            items {
              videoId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              guestName
              viewCount
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              createdAt
              updatedAt
            }
            nextToken
          }
          comments {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          commentsCount
          uploadedVideo {
            fileName
            videoContainer
            videoEncoding
          }
          transcriptionSummaryStatus
          transcriptionSummaryError
          transcriptionSummary
          transcriptionObject {
            key
            bucket
            accessLevel
            identityId
          }
          updatedAt
        }
        comment {
          id
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          videoId
          channelId
          parentId
          content
          richContent
          videoTimestamp
          resolved
          replies {
            items {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            nextToken
            count
          }
          replyCount
          parentCreatedAt
          createdAt
          updatedAt
        }
        emailMessage {
          id
          videoId
          customerId
          channelId
          to
          note
          emailStatus {
            email
            status
            reject_reason
            _id
            deliveredAt
            opens
          }
          subject
          contacts {
            email
            contactId
          }
          createdAt
          updatedAt
        }
        text {
          content
          richContent
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
        }
        file {
          fileName
          fileObject {
            key
            bucket
            accessLevel
            identityId
          }
          status
          customerId
          customerMeta {
            id
            email
            firstName
            lastName
            profilePhoto {
              key
              bucket
              accessLevel
              identityId
            }
            brandLogo {
              key
              bucket
              accessLevel
              identityId
            }
            calendlyUrl
            lastSeen
            settings {
              notifyEmailWatched
              notifyEmailComment
              notifyUnseenMessages
              timezone
              pushNotifications {
                video
                comment
                reply
                text
              }
              lastChannel
              enableSplashScreen
              termsAndConditions {
                version
                accepted
                acceptedAt
              }
              channelRecentActivityDays
            }
            stripeId
            createdAt
            updatedAt
          }
          mimeType
          metadata
        }
        engagement {
          items {
            customerId
            seen
            seenAt
            videoProgress
          }
          nextToken
        }
        referencePostId
        referencePost {
          id
          channelId
          accessId
          customerId
          postType
          video {
            id
            createdAt
            customerId
            channelId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            title
            searchTitle
            status
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            filePresignedUrl
            duration
            name
            thumbnailObject {
              key
              bucket
              accessLevel
              identityId
            }
            accessType
            accessId
            password
            width
            height
            viewsCountTotal
            viewsCountUnique
            viewsList {
              items {
                videoId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                guestName
                viewCount
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                createdAt
                updatedAt
              }
              nextToken
            }
            comments {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            commentsCount
            uploadedVideo {
              fileName
              videoContainer
              videoEncoding
            }
            transcriptionSummaryStatus
            transcriptionSummaryError
            transcriptionSummary
            transcriptionObject {
              key
              bucket
              accessLevel
              identityId
            }
            updatedAt
          }
          comment {
            id
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            videoId
            channelId
            parentId
            content
            richContent
            videoTimestamp
            resolved
            replies {
              items {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              nextToken
              count
            }
            replyCount
            parentCreatedAt
            createdAt
            updatedAt
          }
          emailMessage {
            id
            videoId
            customerId
            channelId
            to
            note
            emailStatus {
              email
              status
              reject_reason
              _id
              deliveredAt
              opens
            }
            subject
            contacts {
              email
              contactId
            }
            createdAt
            updatedAt
          }
          text {
            content
            richContent
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
          }
          file {
            fileName
            fileObject {
              key
              bucket
              accessLevel
              identityId
            }
            status
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            mimeType
            metadata
          }
          engagement {
            items {
              customerId
              seen
              seenAt
              videoProgress
            }
            nextToken
          }
          referencePostId
          referencePost {
            id
            channelId
            accessId
            customerId
            postType
            video {
              id
              createdAt
              customerId
              channelId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              title
              searchTitle
              status
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              filePresignedUrl
              duration
              name
              thumbnailObject {
                key
                bucket
                accessLevel
                identityId
              }
              accessType
              accessId
              password
              width
              height
              viewsCountTotal
              viewsCountUnique
              viewsList {
                items {
                  videoId
                  customerId
                  guestName
                  viewCount
                  createdAt
                  updatedAt
                }
                nextToken
              }
              comments {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              commentsCount
              uploadedVideo {
                fileName
                videoContainer
                videoEncoding
              }
              transcriptionSummaryStatus
              transcriptionSummaryError
              transcriptionSummary
              transcriptionObject {
                key
                bucket
                accessLevel
                identityId
              }
              updatedAt
            }
            comment {
              id
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              videoId
              channelId
              parentId
              content
              richContent
              videoTimestamp
              resolved
              replies {
                items {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                nextToken
                count
              }
              replyCount
              parentCreatedAt
              createdAt
              updatedAt
            }
            emailMessage {
              id
              videoId
              customerId
              channelId
              to
              note
              emailStatus {
                email
                status
                reject_reason
                _id
                deliveredAt
                opens
              }
              subject
              contacts {
                email
                contactId
              }
              createdAt
              updatedAt
            }
            text {
              content
              richContent
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
            }
            file {
              fileName
              fileObject {
                key
                bucket
                accessLevel
                identityId
              }
              status
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              mimeType
              metadata
            }
            engagement {
              items {
                customerId
                seen
                seenAt
                videoProgress
              }
              nextToken
            }
            referencePostId
            referencePost {
              id
              channelId
              accessId
              customerId
              postType
              video {
                id
                createdAt
                customerId
                channelId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                title
                searchTitle
                status
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                filePresignedUrl
                duration
                name
                thumbnailObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                accessType
                accessId
                password
                width
                height
                viewsCountTotal
                viewsCountUnique
                viewsList {
                  nextToken
                }
                comments {
                  nextToken
                  count
                }
                commentsCount
                uploadedVideo {
                  fileName
                  videoContainer
                  videoEncoding
                }
                transcriptionSummaryStatus
                transcriptionSummaryError
                transcriptionSummary
                transcriptionObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                updatedAt
              }
              comment {
                id
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                videoId
                channelId
                parentId
                content
                richContent
                videoTimestamp
                resolved
                replies {
                  nextToken
                  count
                }
                replyCount
                parentCreatedAt
                createdAt
                updatedAt
              }
              emailMessage {
                id
                videoId
                customerId
                channelId
                to
                note
                emailStatus {
                  email
                  status
                  reject_reason
                  _id
                  deliveredAt
                  opens
                }
                subject
                contacts {
                  email
                  contactId
                }
                createdAt
                updatedAt
              }
              text {
                content
                richContent
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
              }
              file {
                fileName
                fileObject {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                status
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                mimeType
                metadata
              }
              engagement {
                items {
                  customerId
                  seen
                  seenAt
                  videoProgress
                }
                nextToken
              }
              referencePostId
              referencePost {
                id
                channelId
                accessId
                customerId
                postType
                video {
                  id
                  createdAt
                  customerId
                  channelId
                  title
                  searchTitle
                  status
                  filePresignedUrl
                  duration
                  name
                  accessType
                  accessId
                  password
                  width
                  height
                  viewsCountTotal
                  viewsCountUnique
                  commentsCount
                  transcriptionSummaryStatus
                  transcriptionSummaryError
                  transcriptionSummary
                  updatedAt
                }
                comment {
                  id
                  customerId
                  videoId
                  channelId
                  parentId
                  content
                  richContent
                  videoTimestamp
                  resolved
                  replyCount
                  parentCreatedAt
                  createdAt
                  updatedAt
                }
                emailMessage {
                  id
                  videoId
                  customerId
                  channelId
                  to
                  note
                  subject
                  createdAt
                  updatedAt
                }
                text {
                  content
                  richContent
                  customerId
                }
                file {
                  fileName
                  status
                  customerId
                  mimeType
                  metadata
                }
                engagement {
                  nextToken
                }
                referencePostId
                referencePost {
                  id
                  channelId
                  accessId
                  customerId
                  postType
                  referencePostId
                  readHorizon
                  postTempId
                  createdAt
                  updatedAt
                }
                readHorizon
                postTempId
                reactions {
                  nextToken
                }
                createdAt
                updatedAt
              }
              readHorizon
              postTempId
              reactions {
                items {
                  postId
                  customerId
                  unicode
                  videoTimestamp
                  channelId
                  incrementBy
                  createdAt
                  updatedAt
                }
                nextToken
              }
              createdAt
              updatedAt
            }
            readHorizon
            postTempId
            reactions {
              items {
                postId
                customerId
                customerMeta {
                  id
                  email
                  firstName
                  lastName
                  calendlyUrl
                  lastSeen
                  stripeId
                  createdAt
                  updatedAt
                }
                unicode
                videoTimestamp
                channelId
                incrementBy
                createdAt
                updatedAt
              }
              nextToken
            }
            createdAt
            updatedAt
          }
          readHorizon
          postTempId
          reactions {
            items {
              postId
              customerId
              customerMeta {
                id
                email
                firstName
                lastName
                profilePhoto {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                brandLogo {
                  key
                  bucket
                  accessLevel
                  identityId
                }
                calendlyUrl
                lastSeen
                settings {
                  notifyEmailWatched
                  notifyEmailComment
                  notifyUnseenMessages
                  timezone
                  lastChannel
                  enableSplashScreen
                  channelRecentActivityDays
                }
                stripeId
                createdAt
                updatedAt
              }
              unicode
              videoTimestamp
              channelId
              incrementBy
              createdAt
              updatedAt
            }
            nextToken
          }
          createdAt
          updatedAt
        }
        readHorizon
        postTempId
        reactions {
          items {
            postId
            customerId
            customerMeta {
              id
              email
              firstName
              lastName
              profilePhoto {
                key
                bucket
                accessLevel
                identityId
              }
              brandLogo {
                key
                bucket
                accessLevel
                identityId
              }
              calendlyUrl
              lastSeen
              settings {
                notifyEmailWatched
                notifyEmailComment
                notifyUnseenMessages
                timezone
                pushNotifications {
                  video
                  comment
                  reply
                  text
                }
                lastChannel
                enableSplashScreen
                termsAndConditions {
                  version
                  accepted
                  acceptedAt
                }
                channelRecentActivityDays
              }
              stripeId
              createdAt
              updatedAt
            }
            unicode
            videoTimestamp
            channelId
            incrementBy
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      videosLimitReached
    }
  }
`;
export const setPostsSeen = /* GraphQL */ `
  mutation SetPostsSeen($input: SetPostsSeenInput!) {
    setPostsSeen(input: $input) {
      customerId
      channelId
      timestamp
      source
      postIds
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
    }
  }
`;
export const publishCustomerChanges = /* GraphQL */ `
  mutation PublishCustomerChanges($input: PublishCustomerChangesInput!) {
    publishCustomerChanges(input: $input) {
      customerId
      channelId
      timestamp
      source
      postIds
      customerMeta {
        id
        email
        firstName
        lastName
        profilePhoto {
          key
          bucket
          accessLevel
          identityId
        }
        brandLogo {
          key
          bucket
          accessLevel
          identityId
        }
        calendlyUrl
        lastSeen
        settings {
          notifyEmailWatched
          notifyEmailComment
          notifyUnseenMessages
          timezone
          pushNotifications {
            video
            comment
            reply
            text
          }
          lastChannel
          enableSplashScreen
          termsAndConditions {
            version
            accepted
            acceptedAt
          }
          channelRecentActivityDays
        }
        stripeId
        createdAt
        updatedAt
      }
    }
  }
`;
export const createGuestCustomer = /* GraphQL */ `
  mutation CreateGuestCustomer(
    $input: CreateScreensightCustomerInput!
    $condition: ModelScreensightCustomerConditionInput
  ) {
    createGuestCustomer(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      profilePhoto {
        key
        bucket
        accessLevel
        identityId
      }
      brandLogo {
        key
        bucket
        accessLevel
        identityId
      }
      calendlyUrl
      lastSeen
      settings {
        notifyEmailWatched
        notifyEmailComment
        notifyUnseenMessages
        timezone
        pushNotifications {
          video
          comment
          reply
          text
        }
        lastChannel
        enableSplashScreen
        termsAndConditions {
          version
          accepted
          acceptedAt
        }
        channelRecentActivityDays
      }
      stripeId
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateScreensightCustomerInput!
    $condition: ModelScreensightCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      profilePhoto {
        key
        bucket
        accessLevel
        identityId
      }
      brandLogo {
        key
        bucket
        accessLevel
        identityId
      }
      calendlyUrl
      lastSeen
      settings {
        notifyEmailWatched
        notifyEmailComment
        notifyUnseenMessages
        timezone
        pushNotifications {
          video
          comment
          reply
          text
        }
        lastChannel
        enableSplashScreen
        termsAndConditions {
          version
          accepted
          acceptedAt
        }
        channelRecentActivityDays
      }
      stripeId
      createdAt
      updatedAt
    }
  }
`;
export const createContact = /* GraphQL */ `
  mutation CreateContact(
    $input: CreateScreensightContactInput!
    $condition: ModelScreensightContactConditionInput
  ) {
    createContact(input: $input, condition: $condition) {
      id
      ownerCustomerId
      firstName
      lastName
      email
      mobilePhone
      contactCustomerMeta {
        items {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateContact = /* GraphQL */ `
  mutation UpdateContact(
    $input: UpdateScreensightContactInput!
    $condition: ModelScreensightContactConditionInput
  ) {
    updateContact(input: $input, condition: $condition) {
      id
      ownerCustomerId
      firstName
      lastName
      email
      mobilePhone
      contactCustomerMeta {
        items {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteContact = /* GraphQL */ `
  mutation DeleteContact(
    $input: DeleteScreensightContactInput!
    $condition: ModelScreensightContactConditionInput
  ) {
    deleteContact(input: $input, condition: $condition) {
      id
      ownerCustomerId
      firstName
      lastName
      email
      mobilePhone
      contactCustomerMeta {
        items {
          id
          email
          firstName
          lastName
          profilePhoto {
            key
            bucket
            accessLevel
            identityId
          }
          brandLogo {
            key
            bucket
            accessLevel
            identityId
          }
          calendlyUrl
          lastSeen
          settings {
            notifyEmailWatched
            notifyEmailComment
            notifyUnseenMessages
            timezone
            pushNotifications {
              video
              comment
              reply
              text
            }
            lastChannel
            enableSplashScreen
            termsAndConditions {
              version
              accepted
              acceptedAt
            }
            channelRecentActivityDays
          }
          stripeId
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
